import _ from 'lodash';

const modalUrls = {
  "preview": "https://try.unbounce.com/sandbox-modal-preview/",
  "overview": "https://try.unbounce.com/sandbox-modal-overview/",
  "logo": "https://try.unbounce.com/sandbox-modal-logo/"
};

const tooltips = [
  {
    selector: ".editor-header-preview-button",
    copy: "Take a look at what your page looks like first! See how it works by starting a trial."
  },
  {
    selector: ".version-control-button-container",
    copy: "Previous versions of your page are all saved here. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".support-menu",
    copy: "See the latest system status update, create a support ticket, and get help here. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".variant-dropdown",
    copy: "Check out the different variants for your A/B testing. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".widget-button-lightbox-button",
    copy: "Add a form or other media to your page by creating a lightbox to house it. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".widget-button-lp-code",
    copy: "Add your fancy custom HTML scripts here! See how it works by starting a trial."
  },
  {
    selector: ".widget-button-video",
    copy: "Add a video to your page! (Pro-tip: they're good for increasing engagement.) " +
    "See how it works by starting a trial."
  },
  {
    selector: ".footer-controls > .responsive-device-container",
    copy: "Toggle this to move between a desktop and mobile view of your page. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".lp-script",
    copy: "Add JavaScript to enhance your page even more with unique branding elements. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".lp-stylesheet",
    copy: "Add CSS to enhance your page even more with unique branding elements. " +
    "See how it works by starting a trial."
  },
  {
    selector: ".helptip-dtr-title",
    copy: "You can pass in dynamic text values to your title, through your page's " +
    "URL. This is useful for increasing message match and quality score of your PPC " +
    "campaigns."
  },
  {
    selector: ".helptip-dtr-keywords",
    copy: "You can pass in dynamic text values to your keywords, through your page's " +
    "URL. This is useful for increasing message match and quality score of your PPC " +
    "campaigns."
  },
  {
    selector: ".helptip-dtr-desc",
    copy: "You can pass in dynamic text values to your description, through your page's " +
    "URL. This is useful for increasing message match and quality score of your PPC " +
    "campaigns."
  },
  {
    selector: ".page-name.crumb",
    copy: "The name of this beautiful page you're working on."
  },
  {
    selector: ".save-template-help",
    copy: "This button only appears to Unbounce employees. Clicking this button will " +
    "save this page as a template in Active Admin."
  }

].map((tip) => {
  // Defaults
  return _.assign(tip, {
    disabled: true,
    color: 'white',
    size: 'large',
    position: 'fixed'
  });
});

export {modalUrls, tooltips};



// WEBPACK FOOTER //
// ./src/control/sandbox/sandbox-config.js